import { combineReducers } from "redux-immutable";
import formData from "@cv-store/reducers/formData";

export default combineReducers({
    formData
});